import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { components } from 'react-select'
// import { STYLES_REACT_SELECT_NEW_MULTIPLE_VALUE } from '../../../../../../constants'
import { CustomInput } from 'reactstrap'
import { SelectWithLabel } from '../../../../../Form'

const Option = (props) => {
  return (
    <div>
      <components.Option {...props} className='filters-wrapper'>
        {/* <input type='checkbox' checked={props.isSelected} onChange={() => null} className={'filters-check'} />{' '} */}
        <CustomInput type='checkbox' checked={props.isSelected} onChange={() => null} className={'filters-check'} />{' '}
        <label className={'filters-label'}>{props.label}</label>
      </components.Option>
    </div>
  )
}

const MultiValue = (props) => (
  <components.MultiValue {...props} className='filters-multivalue-wrapper'>
    {/* <span>{props.data.label}</span> */}
    <span>{'holla'}</span>
  </components.MultiValue>
)

class SelectCheckbox extends Component {
  static propTypes = {
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.node,
        label: PropTypes.node,
      })
    ).isRequired,
    onChangeCallback: PropTypes.func.isRequired,
    label: PropTypes.string,
    defaultValue: PropTypes.array,
  }

  static defaultProps = {
    options: [],
  }

  render() {
    const { options, onChangeCallback, label, defaultValue, ...otherProps } = this.props

    return (
      // <Select
      //   closeMenuOnSelect={false}
      //   isMulti
      //   components={{ Option, MultiValue }}
      //   options={options}
      //   hideSelectedOptions={false}
      //   backspaceRemovesValue={false}
      //   onChange={(e) => onChangeCallback(e)}
      //   {...otherProps}
      //   styles={STYLES_REACT_SELECT_NEW_MULTIPLE_VALUE}
      // />
      <SelectWithLabel
        // name={label}
        // id={label}
        label={label}
        options={options}
        onChange={(e) => onChangeCallback(e)}
        multi
        option={Option}
        multiValues={MultiValue}
        // closeMenuOnSelect={false}
        value={defaultValue}
        selectedValues={defaultValue}
        isClearable
        isRequiredAll
        {...otherProps}
      />
    )
  }
}

export default SelectCheckbox
